export const NO_IMAGE_PLACEHOLDER_URL = '/assets/no-image.svg';
export const NO_PROFILE_IMAGE_PLACEHOLDER_URL = '/assets/no-profile-image.png';
export const JOB_LOGO = '/assets/job_logo.svg';
export const COMING_SOON = '/assets/coming_soon.jpeg';
export const COMING_SOON1 = '/assets/coming_soon1.png';
export const COMING_SOON2 = '/assets/coming_soon2.png';
export const CASTING_LOGO = '/casting-logo.png';
export const CASTING_LOGO_TEXT = '/casting-logo.png';
export const CASTING_COM = '/casting-com-no-logo.png';
export const JOBS_HEADER = '/assets/jobs_header.jpg';
export const ARROW = '/assets/arrow.png';
export const ICON = '/favicon.ico';
export const IMG_BG = '/casting-background.png';
export const BG_OVERLAY = '/background-overlay.svg';
export const OVAL_BLUE = '/oval-blue.png)';
